import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 grid-rows-2 gap-x-4 gap-y-4" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Закрыть")

import { reactive, ref, onMounted } from "vue";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Modal from "@/components/common/Modal.vue";
import { useStore } from "vuex";
import { TransferAuthorityActions } from "@/store/modules/transferAuthority/actions";
import Button from "@/components/common/Button.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: Number,
    required: true,
  },
  show: {
    type: Boolean,
    default: false,
  },
},
  emits: ["hide"],
  setup(__props, { emit }) {

const props = __props




const state = reactive({
  closeReason: "",
});
const rules = {
  closeReason: { required },
};

const store = useStore();

const submitted = ref(false);
const v$ = useVuelidate(rules, state);

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  await store
    .dispatch(TransferAuthorityActions.CLOSE, {
      id: props.id,
      closeReason: state.closeReason,
    })
    .then(async () => {
      state.closeReason = "";

      emit("hide");
    })
    .catch((error) => {
      console.error(error.data.data);
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hide'))),
    show: __props.show,
    title: "Закрыть права"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", {
              class: _normalizeClass(["input-form-label", {
              'p-error': _unref(v$).closeReason.$invalid && submitted.value,
            }])
            }, " Причина закрытия ", 2),
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(["input-form w-full", {
              'p-invalid': _unref(v$).closeReason.$invalid && submitted.value,
            }]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).closeReason.$model) = $event))
            }, null, 2), [
              [_vModelText, _unref(v$).closeReason.$model]
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(Button, { type: "submit" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})